export default "__VITE_ASSET__HoFt3aFB__"